import Paragraph from './paragraph';
import { computed } from '@ember/object';
import Em from 'ember';
export default Paragraph.extend({
  type: 'listItem',
  splitType: 'listItem',
  tagName: 'li',
  blockReplacements: [],
  canAlign: false,
  openingTag: computed('tagName', 'id', 'generatedAt', function () {
    return `<${this.tagName} data-id="${this.id}" data-generated-at="${this.generatedAt}">`;
  }),
  serialized: Em.computed('serializedInnerHtml', function () {
    return this.get('serializedInnerHtml');
  })
});